import { Component, OnInit, signal, computed } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { SelectItem } from 'primeng/api';
import { formatDate } from '@angular/common';
import { deepClone, getDateWithOffset } from '../../../../helpers/utils';
import { enableSelectTimeOffEmployee, getManageTimeOffList, loadViewableCampuses, resetTimeOffApproval, resetTimeOffApprovalSuccess, saveTimeOffApproval, saveTimeOffApprovalSuccess, saveTimeOffRequestSuccess, showApproveTimeOffRequest, showEditTimeOffRequest } from '../../../../core/store/timeoff/timeoff.actions';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { TimeOffClosedPeriodModel, TimeOffModel } from '../../../../models/timeoffModel';
import { tap } from 'rxjs';
import { loadEmployeeUsers } from '../../../../core/store/employee/employee.action';
import { UserAutoCompleteItem } from '../../../../models/utilModels';
import { TimeoffService } from '../../../../core/services/timeoff.service';
import { AlertService } from 'src/app/shared/services/alert.service';

@Component({
    selector: 'app-list-timeoff-manage',
    templateUrl: './list-timeoff-manage.component.html',
    styleUrls: ['./list-timeoff-manage.component.scss'],
    standalone: false
})
export class ListTimeoffManageComponent extends BaseComponent implements OnInit {
  filter: any;
  timeOffList: PagingResultsModel<TimeOffModel>;

  loadingList: boolean = true;
  canEdit: boolean = false;
  canViewPto: boolean = false;
  canManageClosedPeriods: boolean = false;
  readonly manageTimeOffClosedPeriodsPermissionId = 11026;

  campusList: SelectItem[];
  closedPeriodCampusList: SelectItem[] = [{ label: "All campuses", value: 0 }];
  campusId: number = 0;
  closedPeriods: TimeOffClosedPeriodModel[] = [];
  closedPeriodForm: TimeOffClosedPeriodModel = this.getNewClosedPeriod();
  loadingClosedPeriods: boolean = false;
  savingClosedPeriod: boolean = false;
  closedPeriodsLoaded: boolean = false;
  closedPeriodsCollapsed: boolean = true;

  selectedUserEmployee: UserAutoCompleteItem;
  userList: UserAutoCompleteItem[];
  userId: number = 0;

  startDate: string = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
  endDate: string = formatDate(getDateWithOffset(14), 'yyyy-MM-dd', 'en-US');

  statusList: SelectItem[];
  statusId: number = 1;
  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private timeoffService: TimeoffService,
    private alertService: AlertService) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store.select(s => s.timeoffState.loadingManageTimeOffList).subscribe(loadingList => {
        this.loadingList = loadingList;
      }),
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        const couldManageClosedPeriods = this.canManageClosedPeriods;
        this.canEdit = permissionIDs && !!permissionIDs.find(p => p === 186);
        this.canViewPto = permissionIDs && !!permissionIDs.find(p => p === 3103 || p === 3104);
        this.canManageClosedPeriods = permissionIDs && !!permissionIDs.find(p => p === this.manageTimeOffClosedPeriodsPermissionId);

        if (this.canManageClosedPeriods && !couldManageClosedPeriods && !this.closedPeriodsLoaded) {
          this.loadClosedPeriods();
        }
      }),
      this.store.select(s => s.timeoffState.campuses).subscribe(campuses => {
        this.campusList = campuses && campuses.length > 0 ? campuses
          : [{ label: 'loading...', value: undefined }];
        const allCampusesOption: SelectItem = { label: "All campuses", value: 0 };
        this.closedPeriodCampusList = [allCampusesOption, ...(campuses || []).filter(x => x.value)];
        if (campuses.length == 1) {
          this.campusId = this.campusList[0].value;
        }
      }),      
      this.store.select(s => s.employeeState.employeeUsers).subscribe(users => {
        this.userList = users.map(x => ({
          id: x.value,
          name: x.label
        }));
      }),
      this.store.select(s => s.timeoffState.manageTimeOffList).subscribe(list => {
        this.timeOffList = list;
        if(list != null)
     	  	  	  this.totalRecords.set(list.totalRecords);
      }),
      this.actions$.pipe(
        ofType(saveTimeOffRequestSuccess),
        tap(action => {
          this.reloadList();
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(saveTimeOffApprovalSuccess),
        tap(action => {
          this.reloadList();
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(resetTimeOffApprovalSuccess),
        tap(action => {
          this.reloadList();
        })
      ).subscribe(),
    );

    this.store.dispatch(loadViewableCampuses());
    this.statusList = [{ label: "All", value: 0 }, { label: "Pending", value: 1 }, { label: "Approved", value: 2 },
      { label: "Denied", value: 3 }, { label: "Pending & Approved", value: 4 }];
  }

  reloadFilter(event) {
    this.filter = event;
    this.reloadList();
  }


  getStaffList(event) {
    this.store.dispatch(loadEmployeeUsers({
      prefixText: event.query,
      programId: this.campusId,
      payrollClassificationId: 0,
      showTerminated: true,
      showInactive: true
    }));
  }

  reloadListAfterStaffChage(selectedUser) {
    if (typeof selectedUser.value.id !== 'number') {
      return;
    }

    this.userId = selectedUser.value.id;
    this.reloadList();
  }

  reloadListAfterClear(event) {
    
    this.userId = 0;
    this.reloadList();
  }

  reloadList() {
    this.filter = deepClone(this.filter);

    this.filter.filters.userId = { Name: 'userId', Value: { value: this.userId.toString() } };
    this.filter.filters.programId = { Name: 'programId', Value: { value: this.campusId.toString() } };
    this.filter.filters.startDate = { Name: 'startDate', Value: { value: this.startDate } };
    this.filter.filters.endDate = { Name: 'endDate', Value: { value: this.endDate } };
    this.filter.filters.statusId = { Name: 'statusId', Value: { value: this.statusId.toString() } };

    this.store.dispatch(getManageTimeOffList({
      filter: this.filter
    }));
  }

  get filteredClosedPeriods(): TimeOffClosedPeriodModel[] {
    const selectedStartDate = this.startDate || null;
    const selectedEndDate = this.endDate || null;

    return (this.closedPeriods || []).filter(period => {
      const matchesCampus = this.campusId <= 0 || !period.programId || period.programId === this.campusId;
      const periodStartDate = period.startDate ? formatDate(period.startDate, 'yyyy-MM-dd', 'en-US') : null;
      const periodEndDate = period.endDate ? formatDate(period.endDate, 'yyyy-MM-dd', 'en-US') : null;
      const overlapsSelectedDates = (!selectedEndDate || !periodStartDate || periodStartDate <= selectedEndDate)
        && (!selectedStartDate || !periodEndDate || periodEndDate >= selectedStartDate);

      return matchesCampus && overlapsSelectedDates;
    });
  }

  toggleClosedPeriods() {
    this.closedPeriodsCollapsed = !this.closedPeriodsCollapsed;
  }

  newTimeOffRequest() {
    this.store.dispatch(enableSelectTimeOffEmployee());
    this.editTimeOffRequest([]);
  }

  editTimeOffRequest(request) {
    this.store.dispatch(showEditTimeOffRequest({ timeOffRequest: request }));        
  }

  splitChanges(changes: string){
    if(changes == null || changes == ""){
      return;
    }
    var changesArray = changes.split(",");
    return changesArray;
  }

  approveTimeOffRequest(request: TimeOffModel) {
    let timeOff = deepClone(request) as TimeOffModel;    
    timeOff.approved = true;
    timeOff.denied = false;       
    this.store.dispatch(saveTimeOffApproval({ timeOffRequest: timeOff }));
  }

  denyTimeOffRequest(request: TimeOffModel) {
    let timeOff = deepClone(request) as TimeOffModel;
    timeOff.approved = false;
    timeOff.denied = true;
    this.store.dispatch(saveTimeOffApproval({ timeOffRequest: timeOff }));
  }

  commentTimeOffRequest(request: TimeOffModel) {      
    this.store.dispatch(showApproveTimeOffRequest({ timeOffRequest: request }));
  }

  resetTimeOffRequest(request: TimeOffModel) {    
    this.store.dispatch(resetTimeOffApproval({ timeOffRequest: request }));
  }

  loadClosedPeriods() {
    if (!this.canManageClosedPeriods) {
      this.closedPeriods = [];
      this.loadingClosedPeriods = false;
      return;
    }

    this.closedPeriodsLoaded = true;
    this.loadingClosedPeriods = true;
    this.timeoffService.getTimeOffClosedPeriods().subscribe(
      periods => {
        this.closedPeriods = periods;
        this.loadingClosedPeriods = false;
      },
      error => {
        this.loadingClosedPeriods = false;
        this.alertService.error(error?.error || "Error loading closed request periods.");
      }
    );
  }

  saveClosedPeriod() {
    if (!this.canManageClosedPeriods) {
      this.alertService.error("Not authorized");
      return;
    }

    if (!this.closedPeriodForm.startDateString || !this.closedPeriodForm.endDateString) {
      this.alertService.error("Please select a start and end date.");
      return;
    }

    this.savingClosedPeriod = true;
    this.timeoffService.saveTimeOffClosedPeriod(this.closedPeriodForm).subscribe(
      period => {
        this.savingClosedPeriod = false;
        this.alertService.success("Closed request period saved.");
        this.closedPeriodForm = this.getNewClosedPeriod();
        this.loadClosedPeriods();
      },
      error => {
        this.savingClosedPeriod = false;
        this.alertService.error(error?.error || "Error saving closed request period.");
      }
    );
  }

  editClosedPeriod(period: TimeOffClosedPeriodModel) {
    if (!this.canManageClosedPeriods) {
      return;
    }

    this.closedPeriodForm = {
      ...period,
      programId: period.programId || 0,
      startDateString: period.startDateString || formatDate(period.startDate, 'yyyy-MM-dd', 'en-US'),
      endDateString: period.endDateString || formatDate(period.endDate, 'yyyy-MM-dd', 'en-US')
    };
  }

  cancelClosedPeriodEdit() {
    this.closedPeriodForm = this.getNewClosedPeriod();
  }

  removeClosedPeriod(period: TimeOffClosedPeriodModel) {
    if (!this.canManageClosedPeriods) {
      this.alertService.error("Not authorized");
      return;
    }

    this.alertService.confirm("Remove Closed Period", "Remove this closed request period?").subscribe(answer => {
      if (!answer) {
        return;
      }

      this.timeoffService.removeTimeOffClosedPeriod(period.timeOffClosedPeriodId).subscribe(
        success => {
          this.alertService.success("Closed request period removed.");
          this.loadClosedPeriods();
        },
        error => {
          this.alertService.error(error?.error || "Error removing closed request period.");
        }
      );
    });
  }

  getNewClosedPeriod(): TimeOffClosedPeriodModel {
    return {
      timeOffClosedPeriodId: 0,
      programId: 0,
      startDateString: formatDate(new Date(), 'yyyy-MM-dd', 'en-US'),
      endDateString: formatDate(getDateWithOffset(14), 'yyyy-MM-dd', 'en-US'),
      message: "Time off requests are closed for this time period. You can still submit, but this may not be approved.",
      isActive: true
    };
  }
}
